import React from 'react'
import Formsy from 'formsy-react'
import RaisedButton from 'material-ui/RaisedButton'
import { compose, withState, setDisplayName, defaultProps } from 'recompose'
import { FormsyText } from 'formsy-material-ui'
import Subheader from 'material-ui/Subheader'
import Paper from 'material-ui/Paper'
import glamorous from 'glamorous'

const Header = glamorous.h1(
  {
    fontSize: 30,
    textAlign: 'center',
    color: '#4a4a4a',
    marginBottom: 20,
  }
)

const LoginForm = compose(
  setDisplayName('Login Form'),
  withState('canSubmit', 'setCanSubmit', false),
  defaultProps({
    onSignIn: (model) => console.log('model', model),
  })
)(
  ({
    onSignIn,
    canSubmit,
    setCanSubmit,
    isSigningInMessage,
    errorMessage,
  }) => {
    return (
      <Paper style={{ minWidth: 500, padding: 20, display: 'inline-block' }}>
        <Header>SIGN IN</Header>
        <Formsy.Form
          onValid={() => setCanSubmit(true)}
          onInvalid={() => setCanSubmit(false)}
          onValidSubmit={onSignIn}
        >
          <FormsyText
            name="email"
            validations="isEmail"
            validationError={"This is not an email."}
            floatingLabelText="Email"
            hintText="enter your email."
          />
          <br />
          <FormsyText
            name="password"
            type="password"
            floatingLabelText="Password"
            hintText="enter your password."
          />
          <br />
          <RaisedButton
            style={{ marginTop: 50, marginBottom: 20 }}
            type="submit"
            label="Submit"
            primary
            disabled={!canSubmit}
          />
        </Formsy.Form>
        {isSigningInMessage &&
          <Subheader style={{ color: '#a3a3a3' }}>{isSigningInMessage}</Subheader>
        }
        {errorMessage &&
         <Subheader style={{ color: '#ff3d4e' }}>{errorMessage}</Subheader>
        }
      </Paper>
    )
  }
)

LoginForm.propTypes = {}
LoginForm.defaultProps = {}

export default LoginForm



// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js